import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ApplyLeavesProps {
  className?: string;
  width?: number;
  height?: number;
}

const ApplyLeavesIcon = function ApplyLeavesIcon({
  className,
  width,
  height,
}: ApplyLeavesProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <rect className={twMerge(className, 'fill-transparent')} x="2" y="5" width="17" height="14" rx="2" stroke="#222222" />
      <path className={twMerge(className, 'fill-transparent')} d="M2 10L19 10" stroke="#222222" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-transparent')} d="M11 12L11 14.5" stroke="#222222" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-transparent')} d="M11 16.25V16" stroke="#222222" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-transparent')} d="M7 2L7 6" stroke="#222222" strokeLinecap="round" />
      <path className={twMerge(className, 'fill-transparent')} d="M14 2L14 6" stroke="#222222" strokeLinecap="round" />
      <circle className={twMerge(className, 'fill-transparent')} cx="18" cy="18" r="4" fill="white" stroke="#222222" />
      <path className={twMerge(className, 'fill-transparent')} d="M16 18L17.3687 19.825C17.432 19.9093 17.5601 19.9038 17.6159 19.8145L20 16" stroke="#222222" strokeLinecap="round" />
    </svg>
  );
};

ApplyLeavesIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default ApplyLeavesIcon;
